// @flow

import Promise from 'bluebird';

import { lmisUrl } from 'src/config';
import {
  createUnauthenticatedHttpClient,
  withRequestId
} from 'src/modules/seek-api-request';

type LmisParams = {
  placement: string,
  location: Locale,
  loggedin: boolean,
  classification?: string,
  roleId?: string
};

const getLmis = ({
  lmisParams,
  requestId
}: {
  lmisParams: LmisParams,
  requestId: string
}) => {
  return new Promise(resolve =>
    createUnauthenticatedHttpClient()
      .send({
        timeout: 8000, // Avg 4600, so use maximum of 8000
        url: lmisUrl,
        label: 'lmis',
        params: lmisParams,
        headers: {
          ...withRequestId(requestId)
        }
      })
      .then(({ data, headers }) => {
        resolve({
          content: data,
          lmisType: headers['skl-lmis'],
          lmisContextType: headers['skl-lmis-type']
        });
      })
  );
};

export default {
  getLmis
};
